'use strict';


const { queryAll, queryFirst, hasClass } = require('./domUtil');
const { clearForm } = require('./clientSideValidation').functions;
const ADDRESS_SUGGESTION_END_POINT = 'https://maps.googleapis.com/maps/api/js';
const googleAPICall = document.createElement('script');
const keyAddressSuggestion = queryFirst('#googleAddressSuggestionKey');
const addressSuggestionCount = queryFirst('#googleSuggestionAtCount');
const addressSuggestionSelector = queryAll('.js-address-suggestions');
const keyAddressSuggestionValue = keyAddressSuggestion ? keyAddressSuggestion.value : '';
const minCountNumber = parseInt(addressSuggestionCount.value);

googleAPICall.src = `${ADDRESS_SUGGESTION_END_POINT}?libraries=places&key=${keyAddressSuggestionValue}`;
if (!queryFirst('.store-locator-container')) {
    document.head.append(googleAPICall);
}

/**
 * Initialization Google Address Autocomplete
 */
if (addressSuggestionSelector.length) {
    addressSuggestionSelector.forEach(inputEl => {
        let autoCompleteInitiated = false;

        inputEl.addEventListener('keyup', e => {
            const { target } = e;
            const targetVal = target.value;

            if (!autoCompleteInitiated && targetVal.length >= minCountNumber) {
                autoCompleteInitiated = true;
                initAutocomplete(target);
            }
        });
    });
}

/**
 * Handle error scenario for google address suggestions
 * Defined global function will be called automatically when the authentication fails
 */
window.gm_authFailure = () => {
    $('input.gm-err-autocomplete').attr('disabled', false).css('background-image', 'none');
};

/**
 * This method includes google api for google address suggestions
 * in pages account, billing, shipping and store search.
 */

function initAutocomplete(addressField) {
    const formDiv = addressField.closest('form');
    const countryField = queryFirst('.address-country', formDiv);
    const countriesList = queryFirst('#googleSuggestionEnabledCountries').value;
    let country = ($(countryField).val() || countriesList).toLowerCase();

    // Create the autocomplete object, restricting the search predictions to
    // addresses defined in pref
    const autocomplete = new google.maps.places.Autocomplete(addressField, {
        componentRestrictions: { country: country },
        types: ['address'],
        fields: ['address_components', 'geometry', 'name']
    });
    addressField.focus();
    autocomplete.addListener('place_changed', function () {
        if ($(document).find('.store-locator-container.container-sl').length) {
            return;
        }

        const formDiv = addressField.closest('form');
        const place = autocomplete.getPlace();
        const addressField2 = queryFirst('.address-two', formDiv);
        const cityField = queryFirst('.address-city', formDiv);
        const stateField = queryFirst('.address-state', formDiv);
        const countryField = queryFirst('.address-country', formDiv);
        const postalField = queryFirst('.zipcode', formDiv);
        let address1 = '', postcode = '', city = '', country = '', state = '';
        let address2 = '';
        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        for (const component of place.address_components) {
            const componentType = component.types[0];

            switch (componentType) {
                case 'street_number': {
                    address1 = `${component.long_name} ${address1}`;
                    break;
                }

                case 'route': {
                    address1 = `${address1}${component.short_name}`;
                    break;
                }

                case 'subpremise': {
                    address2 = `${address1}${component.short_name}`;
                    break;
                }

                case 'postal_code': {
                    postcode = component.short_name;
                    break;
                }

                case 'postal_code_suffix': {
                    postcode = `${postcode}-${component.short_name}`;
                    break;
                }

                case 'locality': {
                    city = component.long_name;
                    break;
                }
                case 'sublocality_level_1': {
                    city = component.short_name;
                    break;
                }
                case 'administrative_area_level_1': {
                    state = component.short_name;
                    break;
                }
                case 'country': {
                    country = component.short_name;
                    break;
                }
            }
            if (hasClass(addressField, 'address-autocomplete')) {
                addressField.value = address1;
                addressField2.value = address2;
                postalField.value = postcode;
                cityField.value = city;
                stateField.value = state;
                if (countryField) {
                    countryField.value = country;
                }

                //setting cursor focus on the second address
                addressField2.focus();
            } else {
                if (postcode) {
                    addressField.value = postcode;
                }
                if (!postcode && city) {
                    addressField.value = city;
                }
            }
        }

        // to update the states dropdown based on country selection
        $(countryField).trigger('change', state);

        clearForm(formDiv);
    });
}
window.initAutocomplete = initAutocomplete;
